// extracted by mini-css-extract-plugin
module.exports = {"imgFluid":"Asset_imgFluid__3h1VT img-fluid","imageColorWrap":"Asset_imageColorWrap__112UN imageColorWrap","imageCircle":"Asset_imageCircle__2ZZEf"};